<template>
    <div class="od-wrapper">
        <loading :show="isLoading"></loading>
        <modal-confirm :show="showConfirm" @onselect="onConfirmSelection">
            <h4>{{confirmMsg}}</h4>
        </modal-confirm>
        <div class="od-toolbar">
            <span class="od-btn-refresh" @click="loadItem">{{lang.common.refresh}}</span>
        </div>

        <div>
            <div class="od-order-card">

                <div class="od-order-body" v-if="item!==null">

                    <div class="od-order-header">
                        <h4 class="od-shop-name">{{item.shop.shopName}}</h4>
                        <div class="od-order-meta">
                            <span class="od-order-num">{{lang.order.orderNum}}: {{item.id}}</span>
                            <span class="od-order-date">Date: {{item.localCreateDate}}</span>
                        </div>

                        <div class="od-state-wrap">
                            <div class="od-state-badge">{{lang.stateLabels.order[item.stateCode]}}</div>
                        </div>
                    </div>


                    <div class="od-items-section">

                        <div v-for="(orderItem,index) in item.items" class="od-item-row" :order-id="orderItem.id">
                            <div class="od-item-header-row">
                                <span class="od-item-index">{{index+1}}</span>
                                <span class="od-item-ref">REF{{orderItem.id}}</span>
                            </div>
                            <div class="od-item-image-col">
                                <img class="od-item-image"
                                     :src="orderItem.post.thumbPath">
                            </div>
                            <div class="od-item-info">
                                <div class="od-item-title">{{orderItem.title}}</div>
                                <div class="od-item-props">
                                    <span v-for="pc in orderItem.propCats" class="od-item-prop">
                                        {{pc.parent.name}}:{{pc.child.name}}
                                    </span>
                                </div>
                            </div>
                            <div class="od-item-price">{{orderItem.price}} x {{orderItem.quant}}</div>
                            <div class="od-item-subtotal">{{orderItem.subTotal}}</div>
                        </div>

                        <div class="od-extra-row" v-for="(extraItem,index) in item.orderExtras">
                            <div class="od-extra-spacer"></div>
                            <div class="od-extra-name">{{extraItem.child.name}}</div>
                            <div class="od-extra-amount">{{extraItem.label.amount}}</div>
                        </div>

                        <div class="od-total-section">
                            <div class="od-total-spacer"></div>
                            <div class="od-total-content">
                                <span class="od-total-label">{{lang.order.total}}({{currency}}):</span>
                                <span v-if="isTotalReady" class="od-total-value">{{item.orderTotal}}</span>
                                <span class="od-total-pending" v-else>{{lang.stateLabels.order[item.stateCode]}}</span>
                            </div>
                        </div>

                        <div class="od-msgs">
                            <div class="od-buyer-msg">{{lang.order.buyerMsg}}: {{item.userMsg}}</div>
                            <div class="od-shop-msg">{{lang.order.shopMsg}}: <span class="od-shop-msg-text">{{item.shopMsg}}</span></div>
                        </div>

                        <div class="od-contact-section">
                            <div class="od-contact-info">
                                <span class="od-contact-label">{{lang.common.name}}:</span>{{item.contact.name}} /
                                <span class="od-contact-label">{{lang.common.phone}}:</span>{{item.contact.phone}}
                            </div>
                            <div>
                                <div class="od-contact-delivery-label">{{lang.contact.deliveryAddress}}:</div>
                                <div class="od-contact-address">{{item.contact.address}}</div>
                            </div>
                            <div v-if="item.contact.pickContact!==null" class="od-pickup-section">
                                <div class="od-pickup-badge">{{lang.common.pickup}}</div>
                                <div class="od-pickup-detail">{{item.contact.pickContact.title}}:{{item.contact.pickContact.phone}}</div>
                                <div class="od-pickup-detail">{{item.contact.pickContact.address}}</div>
                            </div>
                        </div>

                    </div>

                    <div v-if="orderPayable" class="od-payment-section">
                        <div class="od-payment-title">{{lang.order.payMethods}}</div>
                        <div class="od-payment-grid">
                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payPalEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{paypalAccount.info}}</div>
                                    <div class="od-payment-account">{{paypalAccount.accountNo}}</div>
                                    <span id="paypal-button-container"></span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payCashEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{cashAccount.info}}</div>
                                    <div class="od-payment-account">{{cashAccount.accountNo}}</div>
                                    <span @click="setCashPayment" class="od-payment-btn">
                                        {{lang.order.cashOnDelivery}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payFpsEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{fpsAccount.info}}</div>
                                    <div class="od-payment-account">{{fpsAccount.accountNo}}</div>
                                    <span @click="setFpsPayment" class="od-payment-btn">
                                        {{lang.order.payByFps}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payMeEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{payMeAccount.info}}</div>
                                    <div class="od-payment-account">{{payMeAccount.accountNo}}</div>
                                    <span @click="setPayMePayment" class="od-payment-btn">
                                        {{lang.order.payByPayMe}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payWechatEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{wechatpayAccount.info}}</div>
                                    <div class="od-payment-account">{{wechatpayAccount.accountNo}}</div>
                                    <span @click="setWechatpayPayment" class="od-payment-btn">
                                        {{lang.order.payByWechatpay}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payAliEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{alipayAccount.info}}</div>
                                    <div class="od-payment-account">{{alipayAccount.accountNo}}</div>
                                    <span @click="setAlipayPayment" class="od-payment-btn">
                                        {{lang.order.payByAlipay}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payAtmEnabled">
                                <div class="od-payment-option">
                                    <div class="od-payment-info">{{atmAccount.info}}</div>
                                    <div class="od-payment-account">{{atmAccount.accountNo}}</div>
                                    <span @click="setAtmPayment" class="od-payment-btn">
                                        {{lang.order.payByAtm}}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div v-if="paymentSelected!==null && !orderPayable" class="od-selected-payment">
                        <div class="od-selected-payment-card">
                            <h3 class="od-selected-payment-title">{{lang.order.selectedPayment}}</h3>
                            <div class="od-payment-info">{{paymentSelected.account.info}}</div>
                            <div class="od-payment-account">{{paymentSelected.account.accountNo}}</div>
                            <div class="od-selected-payment-state">
                                <div class="od-state-badge">{{lang.stateLabels.order[item.stateCode]}}</div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import modalConfirm from './base/ModalConfirm.vue';
    import loading from './base/Loading.vue';
    export default {
        components: {
            modalConfirm: modalConfirm,
            loading: loading
        },
        props: ["orderId"],
        data: function () {
            return {
                item: null,
                confirmMsg: null,
                showConfirm: false,
                isLoading: false
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.orderDetailApiClient;
            },
            orderPayable: function () {
                return this.item !== null && this.item.stateCode === this.apiClient.orderStateCodes.offerReady;
            },
            isTotalReady: function () {
                return this.item !== null && this.item.stateCode !== this.apiClient.orderStateCodes.active;
            },
            lang: function () {
                return this.$store.getters.lang;
            },
            currency: function () {
                return this.$store.getters.configs.currency;
            },
            payPalEnabled: function () {
                return this.shopConfigs.payPalEnabled;
            },
            payCashEnabled: function () {
                return this.shopConfigs.payCashEnabled;
            },
            payFpsEnabled: function () {
                return this.shopConfigs.payFpsEnabled;
            },
            payAliEnabled: function () {
                return this.shopConfigs.payAliEnabled;
            },
            payWechatEnabled: function () {
                return this.shopConfigs.payWechatEnabled;
            },
            payAtmEnabled: function () {
                return this.shopConfigs.payAtmEnabled;
            },
            shopConfigs: function () {
                return this.$store.getters.shopConfigs;
            },
            cashAccount: function () {
                return this.$store.getters.configs.cashAccount;
            },
            atmAccount: function () {
                return this.$store.getters.configs.atmAccount;
            },
            fpsAccount: function () {
                return this.$store.getters.configs.fpsAccount;
            },
            payMeAccount: function () {
                return this.$store.getters.configs.payMeAccount;
            },
            paypalAccount: function () {
                return this.$store.getters.configs.paypalAccount;
            },
            alipayAccount: function () {
                return this.$store.getters.configs.alipayAccount;
            },
            wechatpayAccount: function () {
                return this.$store.getters.configs.wechatpayAccount;
            },
            paymentSelected: function () {
                if (this.item.payments.length === 0) return null;
                var payment = this.item.payments[0];
                var ret = { payment };
                if (payment.method === 'cash') {
                    ret.account = this.cashAccount;
                    return ret;
                }

                if (payment.method === 'atm') {
                    ret.account = this.atmAccount;
                    return ret;
                }

                if (payment.method === 'fps') {
                    ret.account = this.fpsAccount;
                    return ret;
                }

                if (payment.method === 'payme') {
                    ret.account = this.payMeAccount;
                    return ret;
                }

                if (payment.method === 'paypal') {
                    ret.account = this.paypalAccount;
                    return ret;
                }

                if (payment.method === 'wechatpay') {
                    ret.account = this.wechatpayAccount;
                    return ret;
                }

                if (payment.method === 'alipay') {
                    ret.account = this.alipayAccount;
                    return ret;
                }

                return ret;

            }
        },
        methods: {
            confirmListener: function () { },
            onConfirmSelection: function (positive) {
                this.confirmListener(positive);
            },
            loadItem: function () {
                var $that = this;
                this.item = null;
                this.apiClient.getOrderDetailPrms($that.orderId).done(function (data) {
                    $that.item = null;
                    if (data !== null) {
                        $that.item = data.item;
                        $that.$nextTick(() => {
                            if (data.item.stateCode === $that.apiClient.orderStateCodes.offerReady) {
                                $that.apiClient.loadPaypalPrms().done(function () {
                                    $that.renderPaypalBtn(data.item.id, data.paypalEnvironment);
                                });
                            }
                        });
                    }
                });
            },
            setCashPayment: function () {
                this.setManualPayment("cash", this.lang.order.cashOnDelivery);
            },
            setAtmPayment: function () {
                this.setManualPayment("atm", this.lang.order.payByAtm);
            },
            setFpsPayment: function () {
                this.setManualPayment("fps", this.lang.order.payByFps);
            },
            setPayMePayment: function () {
                this.setManualPayment("payme", this.lang.order.payByPayMe);
            },
            setAlipayPayment: function () {
                this.setManualPayment("alipay", this.lang.order.payByAlipay);
            },
            setWechatpayPayment: function () {
                this.setManualPayment("wechatpay", this.lang.order.payByWechatpay);
            },
            setManualPayment: function (payMethod, payMethodDisplayName) {
                this.confirmListener = (positive) => {
                    this.showConfirm = false;
                    if (positive === true) {
                        this.isLoading = true;//need to handle the case on 401 to stop loading
                        var orderId = this.item.id;
                        this.apiClient.setManualPaymentPrms({ orderId: orderId, method: payMethod }).then((ret) => {
                            this.isLoading = false;
                            this.loadItem();
                        }).fail(() => {
                            this.isLoading = false;
                            alert('fail setPayment');
                        });
                    }
                };
                this.confirmMsg = this.lang.common.confirm + " " + payMethodDisplayName + "?";
                this.showConfirm = true;
            },
            renderPaypalBtn: function (orderId, environment) {
                var _orderPaymentId = null;
                var $that = this;
                paypal.Button.render({
                    env: environment, /* sandbox | production */
                    /* Show the buyer a 'Pay Now' button in the checkout flow */
                    commit: true,
                    /* payment() is called when the button is clicked */
                    payment: function () {
                        /* Set up a url on your server to create the payment */
                        return apiClient.createPaypalPaymentPrms({ orderId: orderId }).then(function (data) {
                            _orderPaymentId = data.orderPaymentId;
                            return data.paymentId;
                        });
                    },
                    /* onAuthorize() is called when the buyer approves the payment */
                    onAuthorize: function (data, actions) {
                        /* Set up the data you need to pass to your server */
                        var payload = {
                            intent: data.intent,
                            orderId: data.orderID,
                            payerId: data.payerID,
                            paymentId: data.paymentID,
                            paymentToken: data.paymentToken,
                            orderPaymentId: _orderPaymentId
                        };
                        /* Make a call to your server to execute the payment */
                        return apiClient.executePaypalPaymentPrms(payload).then(function (res) {
                            if (res.responseText === "ok") {
                                $that.loadItem();
                            }
                        });

                    }
                }, '#paypal-button-container');
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.loadItem);
            this.loadItem();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.loadItem);
        }
    }
</script>